export const calculateTimelineHeight = (zoomLevel: number[], zoomIndex: number): number => {
  const baseHeight = 1080;
  const maxHeight = 1300;
  const minHeight = 800;

  const zoomPercentage = zoomLevel[zoomIndex];
  switch (zoomPercentage) {
    case 1:
      return minHeight;
    case 50:
      return baseHeight;
    case 75:
      return Math.round(minHeight + baseHeight);
    case 100:
      return Math.round(maxHeight + baseHeight);
    default:
      return baseHeight;
  }
};
